// Mock data for model providers and models
const modelsService = {
  // Get available model providers and their models
  getProviders: () => {
    return {
      providers: [
        {
          id: "openai",
          name: "OpenAI",
          models: [
            {
              id: "gpt-4o",
              name: "GPT-4o",
              description: "Most capable GPT-4 model",
            },
            {
              id: "gpt-4o-mini",
              name: "GPT-4o Mini",
              description: "Faster and cheaper GPT-4 variant",
            },
            {
              id: "gpt-3.5-turbo",
              name: "GPT-3.5 Turbo",
              description: "Fast and efficient model",
            },
          ],
        },
        {
          id: "groq",
          name: "Groq",
          models: [
            {
              id: "llama-3.3-70b-versatile",
              name: "Llama 3.3 70B",
              description: "High performance Llama model",
            },
            {
              id: "llama-3.1-8b-instant",
              name: "Llama 3.1 8B",
              description: "Fast and efficient Llama model",
            },
          ],
        },
        {
          id: "anthropic",
          name: "Anthropic",
          models: [
            {
              id: "claude-3-sonnet",
              name: "Claude 3 Sonnet",
              description: "Balanced performance and speed",
            },
            {
              id: "claude-3-haiku",
              name: "Claude 3 Haiku",
              description: "Fast and efficient Claude model",
            },
          ],
        },
        {
          id: "google",
          name: "Google",
          models: [
            {
              id: "gemini-pro",
              name: "Gemini Pro",
              description: "Google's most capable model",
            },
            {
              id: "gemini-pro-vision",
              name: "Gemini Pro Vision",
              description: "Multimodal Gemini model",
            },
          ],
        },
        {
          id: "deepinfra",
          name: "DeepInfra",
          models: [
            {
              id: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
              name: "meta-llama/Llama-3.3-70B-Instruct-Turbo",
              description: "Meta's Llama 3.3 70B Instruct Turbo model",
            },
          ],
        },
      ],
    };
  },

  // Get models for specific provider
  getModelsByProvider: (providerId) => {
    const allProviders = modelsService.getProviders();
    const provider = allProviders.providers.find((p) => p.id === providerId);
    return provider ? provider.models : [];
  },
};

export default modelsService;
